export default __webpack_public_path__ + "static/ShareSection2_uk-8c37ea62ba0c4f42dbe88a9fcd037c25.png";